// routes
// import Manage from 'Routes/manage';
import Field from 'Routes/field';
import Transaction from 'Routes/transaction';
import Setting from 'Routes/setting';
import { AsyncCalendarComponent, AsyncPrivateNoteComponent } from 'Components/AsyncComponent/AsyncComponent';
import Dashboard from 'Routes/dashboard';
import InternalNotice from 'Routes/internal-notice';
import Staff from 'Routes/staff';
import Order from 'Routes/order';

export default [
  {
    path: 'order/*',
    component: Order,
  },
  {
    path: 'field/*',
    component: Field,
  },
  {
    path: 'transaction/*',
    component: Transaction,
  },
  {
    path: 'dashboard/*',
    component: Dashboard,
  },
  {
    path: 'calendar',
    component: AsyncCalendarComponent,
  },
  {
    path: 'setting/*',
    component: Setting,
  },
  {
    path: 'internal-notice/*',
    component: InternalNotice,
  },
  {
    path: 'private-note',
    component: AsyncPrivateNoteComponent,
  },
  {
    path: 'staff/*',
    component: Staff,
  },
];
